export const TOPUP_INITIAL_STATE = "TOPUP_INITIAL_STATE";
export const SELECTED_TOPUP = "SELECTED_TOPUP";
export const SUBMIT_TOPUP = "SUBMIT_TOPUP";
export const HISTORY_TOPUP = "HISTORY_TOPUP";
export const HISTORY_TOPUP_LOADMORE = "HISTORY_TOPUP_LOADMORE";